import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-flow: row nowrap;
  position: ${props => (props.position ? 'absolute' : 'static')};
  left: 0;
  bottom: 42px;
  height: 46px;
  width: 255px;
  background: rgba(23, 43, 77, .5);
  color: white;
  cursor: pointer;
  z-index: 9999;
  user-select: none;

  transform: translateX(${props => (props.visible ? '0%' : '-100%')});
  transition: transform .3s ${props => (props.visible ? 'ease-in' : 'ease-out')};

  &:hover {
    background: #172B4D;
  }
`;

export const Inner = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const TaskbarIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 5px
`;

export const DoubleArrow = styled.img`
  width: 12px;
  height: 10px;
  margin-left: 5px
`;
